import { API } from '../../api';
import { axiosInstance } from '../../axios';
import { IContestDetail } from '@/shared/api/contest/getContests/types';

interface Params {
  lang: string;
}

export const getContests = async (params: Params) => {
  const result = await axiosInstance.get<IContestDetail[]>(API.getContests, {
    params: {
      acf_format: 'standard',
      _embed: '',
      ...params,
    },
  });

  return result.data;
};
